import React, { useContext } from "react";
import Avatar from "../Avatar";
import Button from "../Button";

import { Fragment, useState } from "react";

import moment from "moment-timezone";
import { frontEndURL } from "../../utils/axios";

// import { getUserData } from "../../services/userService";

// import { frontEndURL } from "../../utils/axios";

export function getUserData(user) {
  switch (user.provider) {
    case "bitclout":
      return { ...user.bitclout_data, _id: user._id };
    case "twitter":
      return { ...user.twitter_data, _id: user._id };
    case "instagram":
      return { ...user.instagram_data, _id: user._id };
    case "tiktok":
      return { ...user.tiktok_data, _id: user._id };
    case "metamask":
      return {
        ...user.metamask_data,
        provider: "metamask",
        username: user.metamask_data.wallet_address.slice(0, 15) + "...",
        publickey: null,
        profile_picture: "",
        _id: user._id,
      };
    default:
      return {};
  }
}

function EventCard({
  event,
  showEditOption,
  showRoomLink,
  showCopyIcon,
  isCardSet,
  isEnded = false,
  isHomeEvent = false,
  setCardHeight = null,
  setCardWidth = null,
  roomId,
}) {
  var startTime = moment(event.startDate);
  var endTime = moment(event.endDate);
  var today = moment().endOf("day");
  var tomorrow = moment().add(1, "days").endOf("day");
  const [isOpenLogin, setIsOpenLogin] = useState(false);
  const conatinerRef = React.useRef();

  // const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    // window.addEventListener("resize", () => {
    //   setScreenWidth(window.innerWidth);
    // });
    setTimeout(() => {
      const cardHeight = conatinerRef.current?.clientHeight;
      const cardWidth = conatinerRef.current?.clientWidth;
      if (
        cardHeight &&
        cardWidth &&
        setCardHeight &&
        setCardWidth &&
        !isCardSet
      ) {
        setCardHeight(cardHeight);
        setCardWidth(cardWidth);
      }
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currntTime = moment().format();
  const isLive =
    moment(event.startDate).format() < currntTime &&
    moment(event.endDate).format() > currntTime;

  const _renderEventTime = () => {
    let timeRangeString = "";
    const isAMsame = startTime.format("a") === endTime.format("a");
    if (startTime.format("mm") === "00") {
      timeRangeString =
        timeRangeString + startTime.format(`h${isAMsame ? "" : " A"}`);
    } else {
      timeRangeString =
        timeRangeString + startTime.format(`h:mm${isAMsame ? "" : " A"}`);
    }
    timeRangeString = timeRangeString + "-";
    if (endTime.format("mm") === "00") {
      timeRangeString = timeRangeString + endTime.format("h A");
    } else {
      timeRangeString = timeRangeString + endTime.format("h:mm A");
    }
    const zone = moment.tz.guess();
    const abbr = moment.tz(zone).format("z");
    if (isLive) {
      return (
        <div className="flex flex-row items-center">
          <div className="">LIVE</div>
          {/* <div className='live-ripple'></div> */}
          <span class="live-pulse"></span>
          <span>{`${timeRangeString} ${abbr}`}</span>
        </div>
      );
    }

    if (endTime < new Date()) {
      return `${startTime.format("MMM D,")} ${timeRangeString} ${abbr}`;
    }

    return `${
      startTime < today
        ? "TODAY"
        : startTime < tomorrow
        ? "Tomorrow"
        : startTime.format("MMM D,")
    } ${timeRangeString} ${abbr}`;
  };

  return (
    <div>
      <div className="flex border border-lightGray dark:border-matteGray p-4 rounded-xl space-x-4">
        <div className="w-36">
          <img
            src={event.cover ? event.cover?.urls?.small : ""}
            alt="event"
            className="rounded-lg h-98px w-98px object-cover" // h-40 w-full object-cover
          />
        </div>
        <div className="w-full flex flex-col space-y-4">
          <div className="flex justify-between">
            <p className="font-medium font-ubuntu text-sm text-darkGray">
              <span className="uppercase">{_renderEventTime()}</span>
              <p className="font-medium text-base text-darkNight dark:text-frescoWhite">
                {event.title}
              </p>
            </p>
          </div>
          <div className="flex flex-col space-y-2">
            <div className="flex justify-between">
              <div className="flex items-center -ml-1 cursor-pointer">
                <div class="-space-x-3 flex overflow-hidden">
                  {event.rsvps?.slice(0, 3).map(
                    (rsvp, index) =>
                      rsvp.status === "confirmed" && (
                        <div
                          key={index}
                          class="inline-flex relative overflow-hidden rounded-full border-2 border-white dark:border-navyGray bg-white dark:bg-navyGray "
                        >
                          <Avatar
                            src={getUserData(rsvp.user).profile_picture}
                            alt="avatar"
                            username={getUserData(rsvp.user).username}
                            size="xs"
                            className="w-6 h-6 rounded-full"
                          />
                        </div>
                      )
                  )}
                </div>
                {event?.rsvps?.filter((rsvp) => rsvp.status === "confirmed")
                  .length > 0 ? (
                  <p className="pl-1 font-normal text-sm text-darkGray">
                    {
                      event.rsvps?.filter((rsvp) => rsvp.status === "confirmed")
                        ?.length
                    }{" "}
                    · RSVP
                  </p>
                ) : undefined}
              </div>
              <div>
                <Button variant="vibhut-primary" size="vibhut-sm">
                  <a
                    href={`${frontEndURL}/rooms/${roomId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    RSVP
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventCard;
